import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import About from "@/components/About";
import Statistics from "@/components/Statistics";
import Testimonials from "@/components/Testimonials";
import Certificates from "@/components/Certificates";
import Partners from "@/components/Partners";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ServiceDetail from "@/components/ServiceDetail";
import AboutPage from "@/components/AboutPage";

const HomePage = () => {
  return (
    <>
      <Header />
      <Hero />
      <Services />
      <About />
      {/* <Statistics /> */}
      {/* <Testimonials /> */}
      <Certificates />
      <Partners />
      <Contact />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={
            <>
              <AboutPage />
              <Footer />
            </>
          } />
          <Route path="/services/:slug" element={
            <>
              <ServiceDetail />
              <Footer />
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
